module.exports = "/lucky-balls/img/regular_game/check_infoBar/check_011.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/check_infoBar/check_011.png
// module id = 1135
// module chunks = 0